module.exports = __webpack_public_path__ + "img/horizontal_menu_icon.99f7f67e.svg";